import type { FC } from 'react';

import { LoadingIcon, Stack, Text } from '@eluve/components';

import type { MiniAppSurfaceProps } from '../../types';

import { FindingsReview } from './review/FindingsReview';
import { useFindingsReview } from './review/useFindingsReview';

export const FindingsReviewPanel: FC<MiniAppSurfaceProps> = ({ context }) => {
  const review = useFindingsReview(context);

  if (review.phase === 'preparing') {
    return (
      <Stack className="py-10" align="center" gap={2}>
        <LoadingIcon />
        <Text size="sm" color="secondary">
          Preparing findings from this session…
        </Text>
      </Stack>
    );
  }

  return (
    <div className="h-full overflow-y-auto px-4 pb-6">
      <FindingsReview context={context} review={review} showApply={false} />
    </div>
  );
};
